import styled from 'styled-components';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
 
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  .ant-tabs-nav {
    margin-bottom: 25px;
  }

  .ant-tabs-tab-btn {
    color: #718EBF;
`;
